import { render, staticRenderFns } from "./providers-import.vue?vue&type=template&id=ac16e412"
import script from "./providers-import.vue?vue&type=script&lang=js"
export * from "./providers-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports